import { Injectable } from '@angular/core';
import { ProcessDesignerUIState } from './process-designer.uistate';
import { ElementPropertyConfig, PropertyEntity } from '@farris/ide-property-panel';
import { ProcessListHelpComponent } from '../views/aif-process-list-help/components/process-list-help/process-list-help.component';
import { AifCreationBillProcessConverter } from '../views/aif-process-list-help/AifCreationBillProcessConverter';
import { AifCreationBillActivityPropertyKeys } from '../designer/wf-cell/property-keys/AifCreationBillActivityPropertyKeys';
import { AifLocalePipe } from '../views/aif-ui-common/pipe/aif-ui-common-locale.pipe';

@Injectable()
export class AifCreationBillActivityAdapter {
    constructor(
        private uiState: ProcessDesignerUIState,
        public localPipe: AifLocalePipe
        ) {

    }
    setProperty(obj: any) {
        this.uiState.propertyData = obj.propertyData;
        this.uiState.propertyConfig = this.setConfig(obj.propertyConfig);
    }

    private setConfig(obj: any[]): ElementPropertyConfig[] {
        const propertyConfig: ElementPropertyConfig[] = [];
        if (obj) {
            obj.forEach((element: ElementPropertyConfig) => {
                this.setEntity(element.properties);
                propertyConfig.push(element);
            });
        }
        return propertyConfig;
    }
    private setEntity(obj: PropertyEntity[]) {
        if (obj && obj.length > 0) {
            obj.forEach((item: PropertyEntity) => {
                switch (item.propertyID) {
                    case AifCreationBillActivityPropertyKeys.aifProcessCode: // 单据流编号
                        item.editor = ProcessListHelpComponent;
                        item.converter = new AifCreationBillProcessConverter(this.localPipe);
                        item.editorParams = {
                            bizTypeId: this.uiState.flowFormInfo.flowForm.businessObjectId
                        };
                        break;
                    default:
                        break;
                }
            });
        }
    }
}
